import {
  TeamExternalIntegration,
  StatusCheckEvaluationPredicate,
  ResponseBodyEvaluation
} from 'types/api/status-checks/status-check'
import { IntegrationType } from 'utils/team-external-integrations/team-external-integration-types'

export const DYNATRACE_DOMAIN = 'live.dynatrace'
export const dynatraceStatusCheckIntegration: TeamExternalIntegration = {
  name: 'Dynatrace',
  type: IntegrationType.Dynatrace,
  authUrl: '',
  isPrivateNetworkIntegration: false,
  headers: [{ key: 'Authorization', value: '', label: 'API Key' }],
  url: '',
  sortIndex: 4
}

export const dynatraceBaseUrlRegex = new RegExp(
  '^https:\\/\\/(.+).live.dynatrace.com\\/?$'
)

export const dynatraceHostsUrlRegex = new RegExp(
  '^https:\\/\\/(.+).live.dynatrace.com\\/#newhosts\\/hostdetails(.*);id=([a-zA-Z0-9\\-_]+)'
)

export const dynatraceMonitorsUrlRegex = new RegExp(
  '^https:\\/\\/(.+).live.dynatrace.com\\/ui\\/(http-monitor|browser-monitor)\\/([a-zA-Z0-9\\-_]+)'
)

export const dynatraceEntityUrlRegex = new RegExp(
  '^https:\\/\\/(.+).live.dynatrace.com\\/ui\\/entity\\/([a-zA-Z0-9\\-_]+)'
)

// For reference - this is their API doc
// https://www.dynatrace.com/support/help/dynatrace-api/environment-api/problems-v2/problems/get-problems-list
export const dynatraceApiProblemsRegex = new RegExp(
  '^https:\\/\\/(.+).live.dynatrace.com\\/api\\/v2\\/problems\\\\?.(.+)'
)

export function convertToDynatraceUrl(url: string): string {
  if (dynatraceHostsUrlRegex.test(url)) {
    const domainName = dynatraceHostsUrlRegex.exec(url)?.[1]
    const hostId = dynatraceHostsUrlRegex.exec(url)?.[3]
    return `https://${domainName}.live.dynatrace.com/api/v2/problems?problemSelector=entityId("${hostId}")`
  }

  if (dynatraceMonitorsUrlRegex.test(url)) {
    const domainName = dynatraceMonitorsUrlRegex.exec(url)?.[1]
    const monitorId = dynatraceMonitorsUrlRegex.exec(url)?.[3]
    return `https://${domainName}.live.dynatrace.com/api/v2/problems?problemSelector=entityId("${monitorId}")`
  }

  if (dynatraceBaseUrlRegex.test(url)) {
    const domainName = dynatraceBaseUrlRegex.exec(url)?.[1]
    return `https://${domainName}.live.dynatrace.com/api/v2/problems`
  }

  if (dynatraceEntityUrlRegex.test(url)) {
    const domainName = dynatraceMonitorsUrlRegex.exec(url)?.[1]
    const entityId = dynatraceMonitorsUrlRegex.exec(url)?.[2]
    return `https://${domainName}.live.dynatrace.com/api/v2/problems?problemSelector=status("open")&entitySelector=entityId("${entityId}")`
  }

  if (dynatraceApiProblemsRegex.test(url)) {
    return url
  }

  return null
}

export function convertToDynatraceBaseUrl(url: string): string {
  const regexes = [
    dynatraceHostsUrlRegex,
    dynatraceMonitorsUrlRegex,
    dynatraceBaseUrlRegex,
    dynatraceEntityUrlRegex,
    dynatraceApiProblemsRegex
  ]

  const matchedRegexes = regexes.filter((regex) => regex.test(url))

  if (matchedRegexes.length === 0) {
    return ''
  }

  return `https://${matchedRegexes[0].exec(url)?.[1]}.live.dynatrace.com/`
}

export const dynatraceResponseBodyEvaluationConfiguration: ResponseBodyEvaluation =
  {
    op: 'AND',
    predicates: [
      {
        jpQuery: '.problems.length()',
        type: 'Number',
        comparator: 'EQU',
        rValue: 0
      } as StatusCheckEvaluationPredicate
    ]
  }
